import config from '../configuration/config'
import axios from 'axios'

const url = config.API_URL
const formId = 1

let authorization = null

const client = axios.create({
  baseURL: url,
  json: true
})

const setToken = (token) => {
  authorization = `Bearer ${token}`
  client.defaults.headers.common.Authorization = authorization
}

const generateToken = async (documentType, documentNumber) => {
  const response = await client.post('/generate-token', {
    tipo_documento: documentType,
    numero_documento: documentNumber,
    formulario_id: formId
  })
  const token = response.data.token
  setToken(token)
  return {
    token,
    next: {
      isFinish: response.data.siguiente.es_finalizado,
      question: response.data.siguiente.pregunta,
      options: response.data.siguiente.opciones
    }
  }
}

const saveAnswer = async (questionId, order, value, indice, isFile) => {
  let response

  if (isFile) {
    const formData = new FormData()
    formData.append('pregunta_id', questionId)
    formData.append('file', value, value.name)
    formData.append('indice', indice)
    formData.append('orden_formulario', order)
    response = await client.post('/save-answer', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: authorization
      }
    })
  } else {
    response = await client.post('/save-answer', {
      pregunta_id: questionId,
      valor: value,
      indice,
      orden_formulario: order
    })
  }

  return {
    isFinish: response.data.es_finalizado,
    question: response.data.pregunta,
    options: response.data.opciones
  }
}

const getNextQuestion = async (index) => {
  const response = await client.post('/get-next-question', {
    indice: index
  })

  return {
    isFinish: response.data.es_finalizado,
    question: response.data.pregunta,
    options: response.data.opciones
  }
}

const getPreviousQuestion = async (index) => {
  const response = await client.post('/get-previous-question', {
    indice: index
  })

  return {
    isFinish: response.data.es_finalizado,
    question: response.data.pregunta,
    options: response.data.opciones
  }
}

export {
  saveAnswer,
  getNextQuestion,
  generateToken,
  getPreviousQuestion,
  setToken
}
